import React, { ReactElement, useState } from 'react';
import { Loader } from 'idsk-react-components';
import { Breadcrumbs, HiddenPriorityTitle, Message } from 'slovlex-idsk-react-components';
import Predpisy from '../../module/Predpisy';
import routes from '../../routing/routes';
import { useClient } from '../../context/ClientStatusContext';
import { getPredpisyPage } from '../../client/predpisyClient';
import Layout from '../Layout';

const PredpisyPage = (): ReactElement => {
  const {
    data,
    status,
  } = useClient(
    () => getPredpisyPage(),
  );
  const [displayError, setDisplayError] = useState(true);

  return (
    <Layout>
      <HiddenPriorityTitle>Právne predpisy v jazykoch národnostných menšín</HiddenPriorityTitle>
      <Breadcrumbs
        routeList={[
          {
            to: routes.home.to,
            heading: routes.home.name,
          },
          {
            to: routes.pravnePredpisy.to,
            heading: routes.pravnePredpisy.name,
          },
        ]}
      />
      <Loader loading={status.loading}>
        {(status.responseCode && status.responseCode > 399)
          ? (
            <>
              {displayError && (
              <Message
                type="error"
                onClear={() => setDisplayError(false)}
                headingSize="m"
              >
                Nepodarilo sa načítať právne predpisy.
              </Message>
              )}
            </>
          )
          : (
            <Predpisy
              pravnePredpisy={data}
            />
          )}
      </Loader>
    </Layout>
  );
};

export default PredpisyPage;
